import React from 'react';

import {TRANSFORMATION_STEP_TYPES} from 'analysis-tool/AnalysisToolConstants';
import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

import TransformPill from './TransformPill';

/** @deprecated */
export function getTransformPillSteps(steps: Array<GetAnalysisPipelineStep>): Array<GetAnalysisPipelineStep> {
  return steps.filter((step) => TRANSFORMATION_STEP_TYPES.includes(step.definition.stepType));
}

/** @deprecated */
export function getTransformPills(
  analysis: PipelineGraphQL,
  viewSteps: Array<GetAnalysisPipelineStep>
): Array<JSX.Element> {
  const pills: Array<JSX.Element> = [];
  for (const step of getTransformPillSteps(viewSteps)) {
    pills.push(<TransformPill analysis={analysis} step={step} />);
  }
  return pills;
}
